import { Helmet } from 'react-helmet-async';
// @mui
import { styled } from '@mui/material/styles';
import { Link, Container, Typography, Divider, Stack, Button } from '@mui/material';
// hooks
import useResponsive from '../hooks/useResponsive';
// components
// sections
import { ResetPasswordForm } from '../sections/auth/forgotpassword';

// ----------------------------------------------------------------------

const StyledRoot = styled('div')(({ theme }) => ({
  [theme.breakpoints.up('md')]: {
    display: 'flex',
  },
}));

const StyledSection = styled('div')(({ theme }) => ({
  width: '100%',
  maxWidth: 480,
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  boxShadow: theme.customShadows.card,
  backgroundColor: "#111111",
}));

const StyledContent = styled('div')(({ theme }) => ({
  maxWidth: 480,
  margin: 'auto',
  minHeight: '100vh',
  display: 'flex',
  justifyContent: 'center',
  flexDirection: 'column',
  padding: theme.spacing(12, 0),
}));

// ----------------------------------------------------------------------

export default function LoginPage() {
  const mdUp = useResponsive('up', 'md');

  

  return (
    <>
      <Helmet>
        <title> Reset Password | Genxt </title>
      </Helmet>

      <StyledRoot>

        <Container maxWidth="sm" >
          <StyledContent>
            <Typography variant="h4" gutterBottom sx={{ mb: 5 }}>
              Reset Password
            </Typography>

            <ResetPasswordForm />
          </StyledContent>
        </Container>
      </StyledRoot>
    </>
  );
}
